import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  children: React.ReactNode;
  icon?: boolean;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  icon = false,
  fullWidth = false,
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-base font-medium transition-all duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#1d4ed8] text-white hover:bg-blue-800 shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-[#1F2937] text-white hover:bg-black shadow-md hover:shadow-lg',
    outline: 'border-2 border-[#1F2937] text-[#1F2937] hover:bg-[#1F2937] hover:text-white'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const allClasses = `${baseStyles} ${variants[variant]} ${widthClass} ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={allClasses} data-id="element-9">
        {children}
        {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-10" />}
      </a>;
  }
  return <button className={allClasses} {...props} data-id="element-11">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-12" />}
    </button>;
}